
export default {
  name: 'MusicPlayerTimeline',

  props: {
    progress: { type: Number, required: true }
  },

  data () {
    return {
      isDragging: false,
      left: 0
    }
  },

  computed: {
    position () {
      return this.isDragging ? this.left : this.progress
    }
  },

  methods: {
    update (e) {
      const baseX = this.$refs.timeline.getBoundingClientRect().left
      const baseWidth = this.$refs.timeline.offsetWidth
      const diff = Math.abs(baseX - e.x)
      this.$emit('update', (diff / baseWidth) * 100)
    },
    startDrag () {
      window.addEventListener('mousemove', this.drag)
      window.addEventListener('mouseup', this.stopDrag)
      this.isDragging = true
    },
    stopDrag () {
      window.removeEventListener('mousemove', this.drag)
      window.removeEventListener('mouseup', this.stopDrag)
      this.isDragging = false
      this.$emit('update', this.left)
    },
    drag (e) {
      const baseX = this.$refs.timeline.getBoundingClientRect().left
      const baseWidth = this.$refs.timeline.offsetWidth

      if (e.x <= baseX) {
        this.left = 0
      } else if (e.x > (baseX + baseWidth)) {
        this.left = 100
      } else {
        const diff = Math.abs(baseX - e.x)
        this.left = (diff / baseWidth) * 100
      }
    }
  }
}
